import { AxiosError } from 'axios';

export enum ScormTypes {
    START_CDN_TEST_REQUEST = '@scorm/START_CDN_TEST_REQUEST',
    START_CDN_TEST_SUCCESS = '@scorm/START_CDN_TEST_SUCCESS',
    START_CDN_TEST_FAILURE = '@scorm/START_CDN_TEST_FAILURE',
    START_CDN_TEST_CLEAR = '@scorm/START_CDN_TEST_CLEAR',
}

export interface CdnTestResponse {
    url: string;
}

export interface ScormState {
    data?: string;
    loading: boolean;
    hasError: boolean;
    error?: AxiosError;
    success: boolean;
}
